import { getISOWeek as a } from "./getISOWeek.js";
import { toDate as f } from "./toDate.js";
function i(e, o) {
  const t = f(e), r = a(t) - o;
  return t.setDate(t.getDate() - r * 7), t;
}
export {
  i as default,
  i as setISOWeek
};
//# sourceMappingURL=setISOWeek.js.map
